import { cva } from "class-variance-authority";
import type { Ref } from "react";
import { useTranslation } from "react-i18next";

import {
  SEGMENT_STATUS_CONFIG,
  type SegmentStatus,
} from "@/features/segments/constants";
import { cn } from "@/lib/utils/cn";

const statusDotVariants = cva("size-2 shrink-0 rounded-full", {
  variants: {
    variant: {
      success: "bg-success",
      info: "bg-info",
      neutral: "bg-neutral",
    },
  },
});

type SegmentStatusDotProps = {
  status: SegmentStatus;
  className?: string;
  dotRef?: Ref<HTMLSpanElement>;
};

export function SegmentStatusDot({ status, className, dotRef }: SegmentStatusDotProps) {
  const { t } = useTranslation();
  const { labelKey, variant } = SEGMENT_STATUS_CONFIG[status];

  return (
    <span
      ref={dotRef}
      className={cn(statusDotVariants({ variant }), className)}
      title={t(labelKey)}
    />
  );
}
